<template>
    <button
        class="flex flex-row items-center gap-1.5 px-2 rounded-sm h-[2.375rem] cursor-pointer text-gray-700 hover:bg-gray-600 hover:text-gray-50 group focus:outline-hidden active:bg-gray-900 active:text-gray-50"
        :class="{ 'bg-gray-50 shadow-sm': isActive }"
        type="button"
        :tabindex="isActive ? 0 : -1"
        :aria-checked="isActive"
        role="radio"
        @click="onChange(props.index)"
        @keydown="handleKeyDown"
    >
        <component
            :is="props.icon"
            v-if="icon"
            class="group-hover:text-gray-50 group-active:text-gray-50 text-gray-500"
        />
        <span class="font-semibold leading-none text-nowrap">{{ props.label }}</span>
    </button>
</template>

<script setup lang="ts">
import type { Component } from 'vue';
import { computed, inject } from 'vue';
import { optionSwitchKey } from './injectionKeys';

type OptionSwitchEntryProps = {
    index: number;
    label: string;
    icon?: Component;
};

const props = defineProps<OptionSwitchEntryProps>();

const injectedValues = inject(optionSwitchKey);
if (!injectedValues) {
    throw new Error('TimelineOptionSwitchEntry must be used within a TimelineOptionSwitch component');
}

const { activeIndex, onChange, onMoveFocusLeft, onMoveFocusRight } = injectedValues;
const isActive = computed(() => activeIndex.value === props.index);

function handleKeyDown(event: KeyboardEvent) {
    switch (event.key) {
        case 'ArrowLeft':
            onMoveFocusLeft();
            event.preventDefault();
            break;

        case 'ArrowRight':
            onMoveFocusRight();
            event.preventDefault();
            break;
    }
}
</script>
